import { SponsorForm } from "./SponsorForm";

export function SponsorCreatePage() {
  return <SponsorForm mode="create" />;
}
